const scrollTo = (direction) => {
  if (typeof window !== 'undefined') {
    const top = direction === 'top' ? 0 : 100000000

    window.scroll({
      top,
      left: 0,
      behavior: 'smooth',
    })
  }
}

export default scrollTo
